import { addDoc, collection, getDocs } from "firebase/firestore/lite";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { db } from "./Firebase-config";
const aboutRef = collection(db, "information");
const expRef = collection(db, "Experience");
const skillRef = collection(db, "skills");
const resumeRef = collection(db, "resume");
const storage = getStorage();
// Image URL

export const getAbout = async () => {
  const data = await getDocs(aboutRef).then((res) => {
    return res._docs[0]._document.data.value.mapValue.fields.about.stringValue;
  });
  return data;
};
export const getResume = async () => {
  const data = await getDocs(resumeRef).then((res) => {
    return res._docs[0]._document.data.value.mapValue.fields.link.stringValue;
  });
  return data;
};
export const getInfo = async () => {
  const data = await getDocs(aboutRef).then((res) => {
    const data = res._docs[0]._document.data.value.mapValue.fields;
    const info = {
      name: data.name.stringValue,
      title: data.title.stringValue,
      contact: data.contact.stringValue,
      profile: data.profile.stringValue,
    };
    return info;
  });
  return data;
};

export const getExperience = async () => {
  const data = await getDocs(expRef).then((res) => {
    const data2 = res._docs.map((item) => {
      return item._document.data.value.mapValue.fields;
    });
    return data2;
  });

  return data;
};

//skills

export const getSkills = async () => {
  const data = await getDocs(skillRef).then((res) => {
    return res._docs;
  });

  return data;
};

export const getImage = async (data) => {
  const url = await getDownloadURL(ref(storage, `/skills/${data}.svg`)).then(
    (res) => {
      return res;
    }
  );
  return url;
};

//get Portfolio
const folioRef = collection(db, "portfolio");
export const getFolio = async () => {
  const data = await getDocs(folioRef).then((res) => {
    return res._docs;
  });
  return data;
};
const msgRef = collection(db, "message");
//Post message
export const postMsg = async (data) => {
  const date = new Date().toLocaleString();
  let msg = {
    date: date,
    ...data,
  };
  const res = await addDoc(msgRef, msg);
  return res;
};
